import React from "react";
import ReactDOM from "react-dom/client";
import { CookiesProvider } from "react-cookie";
import { Provider } from "react-redux";

import App from "./App";

import store from './store';

window.addEventListener("error", (event) => {
  const error = event.error;
  if (error?.message?.includes("concurrent rendering")) {
    console.error("React recovered from render error. Underlying cause:", error.cause || error);
  }
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  if (reason?.message?.includes("concurrent rendering")) {
    console.error("React recovered from rejected render error. Underlying cause:", reason.cause || reason);
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"), {
  onRecoverableError(error, errorInfo) {
    if (error?.message?.includes("concurrent rendering")) {
      console.error("React recovered from render error. Underlying cause:", error.cause || error);
      console.error("React component stack:", errorInfo?.componentStack || "(no component stack)");
      return;
    }

    console.error("React recoverable error:", error);
    if (errorInfo?.componentStack) console.error("React component stack:", errorInfo.componentStack);
  },
});
root.render(
  <Provider store={store}>
    <CookiesProvider>
        <React.StrictMode>
          <App />
        </React.StrictMode>
    </CookiesProvider>
  </Provider>
);
